export default __webpack_public_path__ + "static/media/bwTheme-girl.15c77d8f.svg";